import Icon from '../components/Icon.vue'

Icon.register({
  microphone: {
    width: 352,
    height: 512,
    paths: [
      {
        d: 'M176 352C229 352 272 309 272 256V96C272 43 229 0 176 0S80 43 80 96V256C80 309 123 352 176 352zM336 192H320C311.2 192 304 199.2 304 208V256C304 330.8 239.5 390.8 163.2 383.4 96.7 376.9 48 317.1 48 250.3V208C48 199.2 40.8 192 32 192H16C7.2 192 0 199.2 0 208V248.2C0 337.8 64 417.7 152 429.9V464H96C87.2 464 80 471.2 80 480V496C80 504.8 87.2 512 96 512H256C264.8 512 272 504.8 272 496V480C272 471.2 264.8 464 256 464H200V430.2C285.7 418.5 352 344.9 352 256V208C352 199.2 344.8 192 336 192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/microphone.js
// module id = 3UEK
// module chunks = 144